module.exports = __webpack_public_path__ + "img/lens-167-minus-02.b6b54d33.png";